<template>
  <div class="page">
    <div class="centered-box locations-white locations-generic">
      <div class="row">
        <div class="col">
          <div class="home-text">
              We are open for boat rental--weather and water conditions permitting—seven days per week at all four of our locations. See ‘Locations’ for individual boathouse hours.
              <br />
              <br />
            <strong>
              OPEN LABOR DAY, MONDAY, AUGUST 7.
            </strong>  
              <br />
              <br>
              NEW! Our TWILIGHT NATURE PADDLES are back, launching Saturday evenings from our Clark Park boathouse throughout the summer. <strong>Next outing: Saturday, August 22.</strong> See 
              <br>
              our ‘Events’ tab for reservation details. 
              <br /><br />
              Please note: we rent our boats on a first-come, first-served basis; we do not take reservations. See ‘Groups’ for weekday group bookings.
            </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
};
</script>

<style scoped>
.col {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.home-text {
  text-align: center;
}

.page {
  background-image: url("../assets/TampierLakeNew.png");
  flex-direction: column;
}

a.btn:hover {
  color: rgb(192, 80, 77) !important;
}

ul {
  list-style-type: none;
}

a.btn-primary {
  margin-top: -35px;
  margin-bottom: 2px;
  text-align: center;
  display: block;
}

i {
  text-align: center;
  display: block;
}
</style>
